<template>
    <div class="wrapper">
        <div class="container">
            <div class="page-logo">
                <a class="brand" href="#" @click.prevent="$auth.login()">
                  <img src="https://s3.amazonaws.com/tab-assets/logo_mcenter.svg" alt="logo"/>
                </a>
            </div>

            <v-portlet class="page-body">
                <div slot="body">
                    <div class="login-content">
                        <div class="row">
                            <!-- Tuango Plus -->
                            <div class="col-sm-6 col-sm-offset-3">
                                <div class="column-container border-active">
                                    <div class="login-table-head bg-yellow-gold">
                                        <h2 class="no-margin">Tuango Admin</h2>
                                    </div>
                                    <div class="arrow-down border-top-yellow-gold"></div>
                                    <div class="login-table">
                                        <div class="pic">
                                            <img src="/static/img/card-linked.png"
                                                 class="img-responsive" alt="">
                                        </div>
                                    </div>

                                    <div class="login-table-footer">
                                        <button type="button"
                                                class="btn yellow-gold btn-outline login-button sbold uppercase"
                                                @click="$auth.login()">Login
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- End Tuango Plus -->
                        </div>
                    </div><!-- /.login-content -->
                </div>
            </v-portlet>
        </div><!-- /.container -->
    </div><!-- /.wrapper -->
</template>
<script>
  /* ============
   * Datatables.vue Page
   * ============
   *
   * Login page
   */
  import VPortlet from '@/app/components/Portlet'

  export default {
    /**
     * The name of the page.
     */
    name: 'login-index',
    components: {
      VPortlet
    }
  }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_mixins'; // global mixings.

    .wrapper {
        @media(min-width: 768px) {
            height: 100vh;
            display: flex;
            align-items: center;
        }
    }

    .page-logo {
      width: 200px;
      margin: 0 auto;
      padding: 20px 0 30px;
      text-align: center;

      img {
        display: block;
        width: 100%;
      }
    }

    .page-body {
        box-shadow: none;
    }

    .login-content {
        @include clearfix();

        background-color: transparent;

        .arrow-down {
            width: 0;
            height: 0;
            border-left: 15px solid transparent;
            border-right: 15px solid transparent;
            border-top: 15px solid;
            margin: auto;

            &.arrow-blue {
                border-top-color: #3598DC;
            }

            &.arrow-green {
                border-top-color: #32C5D2;
            }

            &.arrow-dark {
                border-top-color: #2F353B;
            }

            &.arrow-grey {
                border-top-color: #f7f9fb;
            }
        }

        .login-title {
            border-bottom: 1px solid;
            border-color: #fff;

            > h1 {
                margin: 20px 0;
            }
        }

        .column-container {
            text-align: center;
            margin: 0;
            background-color: #fff;
            box-shadow: 0 0 12px rgba(0, 0, 0, 0.5);

            @media (max-width: 767px) {
                margin-bottom: 20px;
            }

            &:first-child {
                margin-left: 0;
            }

            &:last-child {
                margin-right: 0;
            }
        }

        .login-table-head {
            color: #fff;
            padding: 20px 0;

            h2 {
                font-size: 26px;
            }

            &.login-1 {
                background-color: #3598DC;
            }

            &.login-2 {
                background-color: #32C5D2;
            }

            &.login-3 {
                background-color: #2F353B;
            }
        }

        .login-table {
            > h3 {
                font-size: 60px;
                position: relative;

                > .login-sign {
                    font-size: 24px;
                    margin-left: -15px;
                    vertical-align: top;
                    top: 15px;
                }
            }

            > p {
                margin-top: 0;
            }

        }

        .login-table-content {
            background-color: #f7f9fb;
            color: #5c6d7e;
            font-weight: 600;
            font-size: 18px;

            .row {
                padding-top: 3px;
                padding-bottom: 3px;

                i {
                    color: #6cade6;
                }

                &:first-child {
                    font-size: 22px;
                    padding-top: 20px;
                }

                &:last-child {
                    padding-bottom: 20px;
                }
            }
        }

        .login-table-footer {
            padding: 20px 0;

            > .login-button {
                font-weight: bold;
                padding: 10px 20px;
            }
        }

        .pic {
            margin: 20px 0;

            > img {
                float: none;
                margin: 0 auto;
                max-width: 50%;
                border-radius: 50% !important;
            }
        }

        // Mobile styles
        @media (max-width: 1024px) {
            .mobile-padding {
                padding: 0;
                margin: 0;

                > i {
                    margin-right: 5px;
                }
            }

            .login-table-content {
                padding-left: 10px;
                padding-right: 10px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/app/pages/Login/Index.vue